<div class="container">
  <p>
    <firebase-ui (signInSuccessWithAuthResult)="signInSuccess($event)"></firebase-ui>
  </p>
</div>
